import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const toSearchableText = (airport) =>
  `${airport.name || ''} ${airport.ident || ''} ${airport.icao_code || ''} ${airport.iata_code || ''} ${
    airport.municipality || ''
  } ${airport.region_name || ''}`.toLowerCase();

function LocationsPage() {
  const [locations, setLocations] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadLocations = async () => {
      try {
        const response = await axios.get('/airports', {
          params: { supported: true },
        });
        if (isMounted) {
          setLocations(response.data);
          setError('');
        }
      } catch {
        if (isMounted) {
          setError('Unable to load supported locations right now.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    void loadLocations();
    return () => {
      isMounted = false;
    };
  }, []);

  const filteredLocations = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) {
      return locations;
    }

    return locations.filter((airport) => toSearchableText(airport).includes(normalizedQuery));
  }, [locations, query]);

  return (
    <div className="inner-page">
      <section className="inner-page-hero" style={{ '--inner-hero-image': "url('/assets/locations.jpg')" }}>
        <p className="inner-page-eyebrow">Network Coverage</p>
        <h1>Our Locations</h1>
        <p>Supported airports from our registered database.</p>
      </section>

      <section className="page-shell">
        <div className="panel-card">
          <div className="panel-header">
            <p>{filteredLocations.length} supported airports</p>
            <input
              className="search-input"
              type="search"
              placeholder="Search by name, city, ICAO or IATA"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
          </div>

          {loading && <p className="status-note">Loading supported locations...</p>}
          {!loading && error && <p className="status-note status-note--error">{error}</p>}

          {!loading && !error && (
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Airport</th>
                    <th>Codes</th>
                    <th>Municipality</th>
                    <th>Region</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLocations.map((airport) => (
                    <tr key={airport.id}>
                      <td>
                        <strong>{airport.name || 'Unnamed Airport'}</strong>
                        <span>{airport.ident || 'No ident'}</span>
                      </td>
                      <td data-label="Codes">
                        <span>{airport.icao_code || '-'}</span>
                        <span>{airport.iata_code || '-'}</span>
                      </td>
                      <td data-label="Municipality">{airport.municipality || '-'}</td>
                      <td data-label="Region">{airport.region_name || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default LocationsPage;
